import { firstValueFrom } from 'rxjs';
import { FilterGroup } from '@custom-components/general/table-filter-bar';
import { locationAddressLine } from '@core/helpers/address.helper';
import { LocationFilterModel, LocationModel } from '@core/models/location.model';
import { LocationService } from '@core/services/location.service';

/** The "location" typeahead pill: the locations the user can see, found by address. */
export function locationFilterGroup(
  locationService: LocationService,
  label: string,
  placeholder: string,
): FilterGroup {
  return {
    key: 'location',
    label,
    type: 'typeahead',
    selection: 'single',
    placeholder,
    search: query => {
      const filter: LocationFilterModel = { limit: 10, offset: 0, address: query };
      return firstValueFrom(locationService.getListLocationsFilter(filter)).then(res =>
        (res.locations ?? []).map(location => ({
          id: String(location.locationId),
          label: locationAddressLine(location),
        })),
      );
    },
    resolve: id =>
      firstValueFrom(locationService.getLocationDetail(id)).then((location: LocationModel) => ({
        id,
        label: locationAddressLine(location),
      })),
  };
}
